// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.App {
    background-color: #032e04;
    color: #c6efce;
}
.bg-light-pink { background-color: #144005 !important; }
.bg-medium-pink { background-color: #022304 !important; }
.bg-dark-pink { background-color: #062302 !important; }
.bg-very-dark-pink { background-color: #073a06 !important; }
.nc-text-primary { background-color: rgba(146, 255, 155, 0.7); color: #c6efce; }
.nc-text-secondary { color: white; }
.nav-link-text { color: rgb(0, 59, 18) !important; }
.nc-background { background-image: linear-gradient(270deg, #8cda89 0%, #59c555 70%) !important; }
.nc-event {background-color: #59f354 !important; color: white;}
.nc-event h4 {font-size: 12px !important; color: white;}
.nc-event a:visited { color: #c6efce; }
.nc-event a:active { color: #c6efce;}
:root {
    --primary: #1eaa79;
    --secondary: #17ff36;
    --light: #b3f6c1;
    --dark: #c6efce;
}
.timeline::after {
    background-color: #66ff55;
}
.timeline-container::after {
    background-color: #003501;
    border-color: #00ac29;
}`, "",{"version":3,"sources":["webpack://./src/css/colors_override.css"],"names":[],"mappings":";AACA;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA,iBAAiB,oCAAoC,EAAE;AACvD,kBAAkB,oCAAoC,EAAE;AACxD,gBAAgB,oCAAoC,EAAE;AACtD,qBAAqB,oCAAoC,EAAE;AAC3D,mBAAmB,0CAA0C,EAAE,cAAc,EAAE;AAC/E,qBAAqB,YAAY,EAAE;AACnC,iBAAiB,gCAAgC,EAAE;AACnD,iBAAiB,6EAA6E,EAAE;AAChG,WAAW,oCAAoC,EAAE,YAAY,CAAC;AAC9D,cAAc,0BAA0B,EAAE,YAAY,CAAC;AACvD,sBAAsB,cAAc,EAAE;AACtC,qBAAqB,cAAc,CAAC;AACpC;IACI,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB","sourcesContent":["\r\n.App {\r\n    background-color: #032e04;\r\n    color: #c6efce;\r\n}\r\n.bg-light-pink { background-color: #144005 !important; }\r\n.bg-medium-pink { background-color: #022304 !important; }\r\n.bg-dark-pink { background-color: #062302 !important; }\r\n.bg-very-dark-pink { background-color: #073a06 !important; }\r\n.nc-text-primary { background-color: rgba(146, 255, 155, 0.7); color: #c6efce; }\r\n.nc-text-secondary { color: white; }\r\n.nav-link-text { color: rgb(0, 59, 18) !important; }\r\n.nc-background { background-image: linear-gradient(270deg, #8cda89 0%, #59c555 70%) !important; }\r\n.nc-event {background-color: #59f354 !important; color: white;}\r\n.nc-event h4 {font-size: 12px !important; color: white;}\r\n.nc-event a:visited { color: #c6efce; }\r\n.nc-event a:active { color: #c6efce;}\r\n:root {\r\n    --primary: #1eaa79;\r\n    --secondary: #17ff36;\r\n    --light: #b3f6c1;\r\n    --dark: #c6efce;\r\n}\r\n.timeline::after {\r\n    background-color: #66ff55;\r\n}\r\n.timeline-container::after {\r\n    background-color: #003501;\r\n    border-color: #00ac29;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
